<h2 mat-dialog-title style="text-align: center; font-size: x-large;">{{'D_T2' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <h3 *ngIf="data.type === 'count'" style="font-size: x-large;">
        {{'MP_P20' | translate}} {{data.correctAnswersCount}} {{'MP_P21' | translate}}
        {{data.totalAnswersCount}}!</h3>
        <h3 *ngIf="data.type === 'percentage'" style="font-size: x-large;">
            {{data.percentage}}% {{'D_P8' | translate}}
        </h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="data.demo" style="font-size: large;" mat-button mat-dialog-close>{{'D_B3' | translate}}</button>
    <button *ngIf="!data.demo" style="font-size: large;" mat-button mat-dialog-close>{{data.type === 'percentage' ? ('D_B2' | translate) :('D_B1' | translate)}}</button>
</mat-dialog-actions>